import ApplyDisclaimer, { ApplyDisclaimerProps } from './apply-disclaimer'

export default ApplyDisclaimer
export type { ApplyDisclaimerProps }
